import IconsColor from '../../components/utility/iconsColor';
import threadListStyles from "../../assets/styles/pageStyles/ruleBasedInbox/threadList/threadList.module.scss";
import { blackColor, deliveredMessageStatusIconColor, failedMessageStatusIconColor, failureLightColor, primaryColor, readMessageStatusIconColor, successLightColor, warningLightColor } from '../../utils/colors';
import GlobalTooltip from '../../components/utility/tooltip/globalTooltip';
import globalStyles from "../../assets/styles/global.module.scss";
import styles from "../../assets/styles/componentStyles/chatbotStyles/chats.module.scss";
import smartAssistStyles from "../../assets/styles/componentStyles/chats/smartAssist.module.scss";
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { Chip, ChipProps, Grid, TooltipProps, Typography } from '@mui/material';
import { CHRONOX_FEATURES, getUserFullName, getValueOrDefault, isFeatureDisabled, isJsonString, isVendor, parseTextToHtml, replacingTemplateMarkdownText } from '../../utils/constants';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import SearchOffIcon from '@mui/icons-material/SearchOff';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import { ThreadManualAgentData } from '../../types/ruleBasedInbox';
import { assignAndRemoveTagExecutionData, chatbot_action_execution_data, ChatbotActionPayloadItem, currentActiveThreadChatbotThreadData, manualAgentData, organizationUserDataModel, RenderThreadMsgInput, saveAndRemoveContactExecutionData, talkToAgentExecutionData, ThreadMsgFields, ticketStatusData, UserMeResponseDataModel, vendorDataResponse, voiceCallActionExecutionData, WhatsAppThreadMessageJson } from '../../models/axiosModel';
import { extractFileNameFromUrl, getAgentName, getAgentNameInitials, getMessage, getMessageType, isCatalogIdAvailableInThread, isCatalogOrderMessage, isInteractiveOrderDetailsMsg } from './utils';
import React from 'react';
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import remarkBreaks from 'remark-breaks';
import rehypeExternalLinks from 'rehype-external-links';
import { INSTAGRAM_ACTION_TYPES, interactiveMessageTypes, patternToRemoveSource, USER_MESSAGE_ACTION_TYPES } from './constants';
import { ACTION_TYPE_NAME } from '../../components/dashboard/flowBuilder/actionTypeName';
import UserMediaMessages from './threadView/components/chatbotActionLogView/userMediaMessages';
import VoiceCallAction from './threadView/components/chatbotActionLogView/voiceCallAction';
import ChatLogsTemplatePreview from './threadView/components/chatbotActionLogView/chatLogsTemplatePreview';
import OrderDetailTemplatePreview from './threadView/components/chatbotActionLogView/orderDetailTemplate/orderDetailTemplatePreview';
import CustomAPIAction from './threadView/components/chatbotActionLogView/customAPIAction';
import SaveVariableAction from './threadView/components/chatbotActionLogView/saveVariableAction';
import ResetVariableAction from './threadView/components/chatbotActionLogView/resetVariableAction';
import VariableAssignmentAction from './threadView/components/chatbotActionLogView/variableAssignmentAction';
import AwaitWebhookAction from './threadView/components/chatbotActionLogView/awaitWebhookAction';
import SaveAndRemoveContactAction from './threadView/components/chatbotActionLogView/saveAndRemoveContactAction';
import TalkToAgentAction from './threadView/components/chatbotActionLogView/talkToAgentAction';
import AssignAndRemoveTagAction from './threadView/components/chatbotActionLogView/assignAndRemoveTagAction';
import RetrieveContactActionLog from './threadView/components/chatbotActionLogView/retrieveContactActionLog';
import WaInteractiveMessagePreview from './threadView/components/chatbotActionLogView/waInteractiveMessagePreview';
import ProductSentCartMessage from './threadView/components/chatbotActionLogView/productSentCartMessage';
import CatalogOrderReceivedMessage from './threadView/components/chatbotActionLogView/orderDetailTemplate/catalogOrderReceivedMessage';
import ContactCard from '../../components/utility/contactCard';
import { CallAudio } from '../../components/dashboard/callAnalysis/callAudio';

export const getfailedMessageStatusIconForMessage = () => {
    return <IconsColor iconName="failedMessageStatusIcon" height={16} width={16} fillColor={failedMessageStatusIconColor} />;
}

export const renderFailedMsgStatusIconWithTooltip = (errorMsg: string) => {
    return (
        <GlobalTooltip 
            placement="top" 
            title={errorMsg ?? ""}
            arrow
        >
            <div className={`${globalStyles.clickable} ${globalStyles.displayFlexStyle}`}>
                {getfailedMessageStatusIconForMessage()}
            </div>
        </GlobalTooltip>
    );
}

export const getMessageStatusIcons = (whatsAppMessageStatus: any, thread: any, aiMessageExecutionActionType: boolean) => {

    // AI Message execution type with no WA status: show failure when media was explicitly not sent to AI
    if(aiMessageExecutionActionType && whatsAppMessageStatus?.length === 0){
        const mediaData = thread?.chatbot_action_execution_data?.media_data?.[0];
        if(mediaData?.flag_sent_to_ai === false) {
            return renderFailedMsgStatusIconWithTooltip(mediaData?.ai_skip_reason ?? '');
        }
    }

    const statusPriority: Record<string, number> = { // High Number High Priority
        sent: 1,
        delivered: 2,
        read: 3,
        failed: 3,
    };

    const latestStatus = [...(whatsAppMessageStatus ?? [])].sort((a: any, b: any) => {
        const aStatus = String(a?.status ?? "").toLowerCase();
        const bStatus = String(b?.status ?? "").toLowerCase();
        return (statusPriority[bStatus] || 0) - (statusPriority[aStatus] || 0);
    });
    const msgStatus = latestStatus?.[0]?.status?.toLowerCase() || "";
    const statusNotes = latestStatus?.[0]?.notes;

    switch (msgStatus) {
        case 'read':
            return <IconsColor iconName="doubleTickWAStatusIcon" height={16} width={16} fillColor={readMessageStatusIconColor} />;
        case 'delivered':
            return <IconsColor iconName="doubleTickWAStatusIcon" height={16} width={16} fillColor={deliveredMessageStatusIconColor} />;
        case 'sent':
            return <IconsColor iconName="singleTickWAStatusIcon" height={16} width={16} fillColor={deliveredMessageStatusIconColor} />;
        case 'failed':
            if (statusNotes) {
                return renderFailedMsgStatusIconWithTooltip(statusNotes);
            }
            return getfailedMessageStatusIconForMessage();
        default:
            if (thread?.isPending) {
                return <AccessTimeIcon sx={{ width: 16, height: 16, color: deliveredMessageStatusIconColor }} />;
            }
            const executionStatusName = thread?.execution_status_name;
            if(executionStatusName?.toLowerCase() === 'error'){
                const errorMsg = thread?.reason_for_failure ?? '';
                return renderFailedMsgStatusIconWithTooltip(errorMsg);
            }
            return <></>;
    }
} 

export const renderUserAvatarDp = (userName: string, flagInsideThread?: boolean) => {
    if (!userName || userName?.startsWith("UNKNOWN") || userName?.toLowerCase() == "anonymous agent") {
        return <AccountCircleIcon className={`${styles.userAvatarIcon} ${flagInsideThread ? styles.userAvatarIconWhatsAppTheme : styles.userAvatarIconPrimaryTheme}`} />
    } else {
        return (
            <Grid item className={`${styles.userAvatarDp} ${flagInsideThread ? styles.userAvatarDpWhatsAppTheme : styles.userAvatarDpPrimaryTheme}`}>
                {userName?.[0]?.toUpperCase()}
            </Grid>
        );
    }
}

export const renderMediaCaption = (mediaCaption: string) => {
    return (
        // <span className={`${globalStyles.tertiaryFontSize} ${globalStyles.secondaryFontWeight}`}>{replacingTemplateMarkdownText(mediaCaption)}</span>
        <pre
            className={`${globalStyles.tertiaryFontSize} ${globalStyles.secondaryFontWeight} ${styles.mediaCaptionStyle}`}
            dangerouslySetInnerHTML={{ __html: replacingTemplateMarkdownText(mediaCaption) }}
        />
    );
}

export const renderFileNameTooltip = (fileName: string, className: string) => {
    return (
        <GlobalTooltip
            title={fileName}
            placement="top"
            arrow
        >
            <span className={className}>
                {fileName}
            </span>

        </GlobalTooltip>
    );
} 

export const renderMediaMsg = (mediaType: string, mediaUrl: string, mediaCaption: string, fileName: string, flagCannedResPreview?: boolean) => {

    let mediaNode = <></>;

    switch (mediaType) {
        case 'image':
        case 'sticker':
            mediaNode = (
                <div className={styles.imageMediaMessageWrapper}>
                    <img src={mediaUrl} alt="Media" className={`${styles.imageMessages} ${!flagCannedResPreview ? styles.imageMessageRadius : ""} ${mediaType === "sticker" ? styles.sticker : ""}`}/>
                    <div className={styles.imageMessageViewIconGrid} onClick={() => window.open(mediaUrl, "_blank")}>
                        <OpenInNewIcon className={styles.imageMessageViewIcon} />
                    </div>
                </div>
            );
            break;
        case 'video':
            mediaNode = <video src={mediaUrl} controls className={`${styles.imageMessages}`}></video>;
            break;
        case 'document':
            mediaNode = <>
                <div className={`${styles.documentMessageDiv} ${flagCannedResPreview ? styles.cannedResDocument : ''}`}>
                    <div style={{ gap: '6px' }} className={`${globalStyles.displayFlex} ${styles.documentFileContent}`}>
                        <div className={styles.documentFileIcon}>
                            <IconsColor iconName="documentFile" fillColor={blackColor} />
                        </div>
                        {renderFileNameTooltip(fileName, `${globalStyles.textCenter} ${globalStyles.tertiaryFontSize} ${globalStyles.secondaryFontWeight} ${styles.documentMessageText}`)}
                    </div>
                    <div className={`${styles.documentMessageOpenInNewTabIcon}`} onClick={() => window.open(mediaUrl, "_blank")}>
                        <IconsColor iconName="openInNewIcon" />
                    </div>
                </div>
            </>
            break;
        case 'audio':
            mediaNode = <>
                <audio controls src={mediaUrl} className={styles.audioMessage} />
                {renderFileNameTooltip(fileName, `${styles.audioFileName}`)}
            </>
            break;
        default:
            mediaNode = <></>
    }

    return (
        <div className={`${globalStyles.displayFlexStyle} ${globalStyles.flexColumn} ${styles.mediaMessagesDiv}`}>
            {mediaNode}
            {mediaCaption &&
                renderMediaCaption(mediaCaption)
            }
        </div>
    );
}

export const renderFormattedMsg = (message: string) => {
    if (isJsonString(message)) {
        return (
            <Markdown
                remarkPlugins={[remarkGfm]}
                rehypePlugins={[
                    [rehypeExternalLinks, { target: '_blank', rel: ['noopener', 'noreferrer'] }],
                ]}
                className={`${styles.reactMarkdownStyle} ${styles.chat_reply_text}`}
            >
                {message.replace(patternToRemoveSource, "")}
            </Markdown>
        )
    }

    const cleanedThread = message.replace(patternToRemoveSource, "");
    const parsedHtml = parseTextToHtml(cleanedThread);

    return (
        <div
            className={`${styles.reactMarkdownStyle} ${styles.chat_reply_text}`}
            dangerouslySetInnerHTML={{
                __html: parsedHtml
            }}
        />
    );
} 

export const getSmartAssistStatusInfo = (flagRequestFailed: boolean | null, functionCallingResponse: any) => {
    if(flagRequestFailed){
        return {
            bgColor: failureLightColor,
            icon: <ErrorIcon className={`${globalStyles.displayFlex} ${globalStyles.contentCenter} ${smartAssistStyles.failureIcon}`} />,
            className: smartAssistStyles.failureIcon,
            statusTitle: "Request Failed",
            statusSubTitle: "Something went wrong while retrieving the information."
        }
    }

    const isSuccess = typeof functionCallingResponse === "object" && functionCallingResponse !== null;

    if(isSuccess) {
        return  {
            bgColor: successLightColor,
            icon: <CheckCircleIcon className={`${globalStyles.displayFlex} ${globalStyles.contentCenter} ${smartAssistStyles.successIcon}`} />,
            className: smartAssistStyles.successIcon,
            statusTitle: "Success",
            statusSubTitle: "Information retrieved successfully"
        }
    } else {
        return  {
            bgColor: warningLightColor,
            icon: <SearchOffIcon className={`${globalStyles.displayFlex} ${globalStyles.contentCenter} ${smartAssistStyles.noDataIcon}`} />,
            className: smartAssistStyles.noDataIcon,
            statusTitle: "No Records Found",
            statusSubTitle: "The search was successfull, but returned no data"
        }
    }
} 

export const renderAgentAvatar = (agentName: string, agentInitials: string) => {
    return (
        <GlobalTooltip
            title={`Assigned to ${agentName}`}
            placement="top"
            arrow
        >
            <div className={threadListStyles.agentAvatar}>
                {agentInitials}
            </div>
        </GlobalTooltip>
    );
}

export const renderAllAssignedAgentAvatar = (manual_agent_data: ThreadManualAgentData[] | manualAgentData[]) => {
    const assignedAgents = manual_agent_data ?? [];
    const showAgentOverflow = assignedAgents.length > 2;
    const visibleAgents = showAgentOverflow ? assignedAgents.slice(0, 1) : assignedAgents;
    const overflowAgents = showAgentOverflow ? assignedAgents.slice(1) : [];
    const agentOverflowCount = overflowAgents?.length;
    const overflowAgentNames = overflowAgents?.map((agent) => getAgentName(agent))?.join(", ");

    return (
        <div className={threadListStyles.agentAvatarGroup}>
            {visibleAgents.map((agent) => (
                <React.Fragment key={agent.thread_manual_agent_id}>
                    {renderAgentAvatar(getAgentName(agent), getAgentNameInitials(agent))}
                </React.Fragment>
            ))}
            {showAgentOverflow && (
                <GlobalTooltip
                    title={`Assigned to ${overflowAgentNames}`}
                    placement="top"
                    arrow
                >
                    <div className={threadListStyles.agentAvatar}>
                        +{agentOverflowCount}
                    </div>
                </GlobalTooltip>
            )}
        </div>
    );
} 

type ThreadTagChipProps = ChipProps & {
    isOption?: boolean;
};

export const renderThreadTagChip = (tagName: string, tagColor: string | null | undefined, chipProps?: ThreadTagChipProps) => {
    const { isOption, ...restChipProps } = chipProps || {};
    const chipColor = tagColor || primaryColor;
    return (
        <Chip
            label={tagName}
            size="small"
            className={isOption ? styles.threadTagOptionChip : undefined}
            sx={{ '--tag-chip-color': chipColor, '--tag-chip-bg': `${chipColor}` }}
            {...restChipProps}
        />
    );
} 

export const getThreadTicketDisableFeatureTooltipTitle = (
    userDetail: UserMeResponseDataModel,
    vendorData: vendorDataResponse | null
): React.ReactNode => {
    if (!isFeatureDisabled(userDetail, CHRONOX_FEATURES['THREAD_TICKETING'])) return '';

    return (
        <>
            Please{" "}
            {isVendor(vendorData, userDetail)
                ? ("contact support")
                : (
                    <a
                        href="https://chronox.ai/contact-us"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        contact support
                    </a>
                )}{" "}
            to enable this feature.
        </>
    );
}

export const threadTicketDisableFeatureTooltipWrapper = (userDetail: UserMeResponseDataModel, position: TooltipProps["placement"], reactNode: React.ReactNode, vendorData: vendorDataResponse | null) => {
    return (
        <GlobalTooltip
            title={getThreadTicketDisableFeatureTooltipTitle(userDetail, vendorData)}
            placement={position}
            arrow
        >
            <span>
                {reactNode}
            </span>
        </GlobalTooltip>
    );
}

export const renderTicketStatusOption = (
    props: React.HTMLAttributes<HTMLLIElement>,
    option: ticketStatusData
) => {
    return (
        <li {...props}>
            <Grid container gap={1} alignItems={"center"}>
                <Grid item className={styles.threadStatusOptionColorCircle} sx={{ backgroundColor: option?.ticket_status_color }}></Grid>
                <span>{option?.ticket_status_name}</span>
            </Grid>
        </li>
    );
}

export const renderAgentOption = (
    props: React.HTMLAttributes<HTMLLIElement>,
    option: organizationUserDataModel | manualAgentData,
    optionKey: React.Key
) => {
    return (
        <li {...props} key={optionKey}>
            {getUserFullName(option)}
        </li>
    );
}

export type ThreadMsgTextType = "text" | "media" | "messageReply" | "contact" | "location" | "audio" | (string & {});

export function getSingleKeyValueBulletMarkdown(messageText: any) {
    if (!messageText || typeof messageText !== 'string') return null;

    const cleanedMessage = messageText.trim();
    if (!isJsonString(cleanedMessage)) return null;

    let parsed;
    try {
        parsed = JSON.parse(
            cleanedMessage
                .replace(/\n(?=\s*[{[(])/g, '')
                .replace(/(?<=[}\])])\n/g, '')
        );
    } catch (e) {
        return null;
    }

    if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) return null;

    const keys = Object.keys(parsed);
    if (keys.length !== 1) return null;

    const key = keys[0];
    const value = parsed[key];
    if (value !== null && typeof value === 'object') return null;

    const displayKey = String(key).toLowerCase().trim();
    const displayValue = String(value ?? '').trim();
    if (!displayKey) return null;

    return `- ${displayKey}: ${displayValue}`;
}

export function markDowntext(text: any, class_name: any) {
    const normalizedText = String(text ?? "").replace(
        /(^|[^*])\*([^*\n]+)\*(?!\*)/g,
        "$1**$2**"
    );

    return (
        <Markdown
            remarkPlugins={[remarkGfm, remarkBreaks]}
            rehypePlugins={[
                [rehypeExternalLinks, { target: '_blank', rel: ['noopener', 'noreferrer'] }],
            ]}
            className={class_name}
        >
            {normalizedText}
        </Markdown>
    );
}

export function renderChatbotActionPayloadSection(
    payloadData: ChatbotActionPayloadItem[] | null | undefined,
    payloadType: string,
    title: string,
    showHrBefore?: boolean
): React.ReactNode {
    const items = payloadData?.filter((payload) => payload?.payload_type === payloadType) ?? [];
    if (items.length === 0) {
        return null;
    }
    return (
        <>
            {showHrBefore && <hr />}
            <div className={styles.chatbotPayloadSectionTitle}>
                {title}
            </div>
            <ul className={styles.chatbotPayloadList}>
                {items.map((payload, index) => {
                    const isEmptyValue = payload?.value === null || payload?.value === undefined || payload?.value === "";
                    const valueClassName = [
                        styles.chatbotPayloadValueStyle,
                        isEmptyValue ? styles.chatbotPayloadEmptyValue : "",
                    ].filter(Boolean).join(" ");
                    return (
                        <li key={`${payloadType}-${payload?.key ?? index}-${index}`} className={styles.chatbotPayloadListItem}>
                            <div className={styles.chatbotPayloadListItemStyle}>
                                <span className={styles.chatbotPayloadKeyStyle}>{payload?.key ?? ""}</span>
                                <span className={valueClassName}>
                                    {getValueOrDefault(payload?.value || "-")}
                                </span>
                            </div>
                        </li>
                    );
                })}
            </ul>
        </>
    );
}

export function renderThreadMsgByType(
    textType: ThreadMsgTextType,
    message_format_id: number,
    chatbotThread: RenderThreadMsgInput,
    initialMessagePreivewOnField?: boolean,
    timeToScroll?: number | string,
    defaultCaseReturnText?: string,
    targetRef?: React.RefObject<HTMLElement | null>
): React.ReactNode {
    if (!chatbotThread) {
        return null;
    }

    const thread = chatbotThread as ThreadMsgFields & {
        media_data?: Array<{
            message_type_name?: string;
            aws_storage_media_url?: string;
            aws_storage_file_name?: string;
            aws_storage_id?: string | number;
        }>;
        contact_information?: unknown;
        chatbot_action_execution_data?: {
            payload_data?: ChatbotActionPayloadItem[];
            message?: string;
        };
        chatbot_thread_value?: string | null;
        order_status?: string | null;
    };

    switch (textType) {
        case "text":
            return (
                <>
                    {
                        message_format_id == 4
                            ?
                            <div style={{ fontStyle: "italic", textDecoration: "underline", cursor: "pointer", color: "blue" }}>
                                {getMessage(thread)?.replace(patternToRemoveSource, "")}
                            </div>
                            :
                            isCatalogIdAvailableInThread(thread).status
                                ?
                                <ProductSentCartMessage
                                    productJson={isCatalogIdAvailableInThread(thread).jsonObj}
                                    targetRef={targetRef}
                                />
                                :
                                isCatalogOrderMessage(thread)?.status ?
                                    <CatalogOrderReceivedMessage
                                        productItems={isCatalogOrderMessage(thread)?.jsonObj}
                                    />
                                :
                                isInteractiveOrderDetailsMsg(thread)?.status ? (() => {
                                    const jsonObj = isInteractiveOrderDetailsMsg(thread)?.jsonObj;
                                    const params = jsonObj?.payload?.action?.parameters;
                                    const orderStatus = thread?.order_status ?? jsonObj?.order_status ?? '';
                                    return (
                                        <OrderDetailTemplatePreview
                                            productItems={params?.order?.items}
                                            currency={params?.currency}
                                            totalAmount={params?.total_amount}
                                            referenceId={params?.reference_id}
                                            bodyText={jsonObj?.body_text}
                                            orderStatus={orderStatus}
                                        />
                                    );
                                })()
                                :
                                <>
                                    {(() => {
                                        const messageText = getMessage(thread)?.replace(patternToRemoveSource, "") ?? "";
                                        const singleKeyBulletMarkdown = getSingleKeyValueBulletMarkdown(messageText);
                                        return markDowntext(
                                            singleKeyBulletMarkdown ?? messageText,
                                            `${styles.reactMarkdownStyle} ${styles.chat_reply_text}`
                                        );
                                    })()}
                                    {thread?.chatbot_action_execution_data && thread?.chatbot_action_execution_data?.payload_data && thread?.chatbot_action_execution_data?.payload_data?.length > 0 &&
                                        <>
                                            {renderChatbotActionPayloadSection(
                                                thread.chatbot_action_execution_data.payload_data,
                                                "flow",
                                                "Form submitted",
                                                (thread?.chatbot_action_execution_data?.message?.length ?? 0) > 0
                                            )}
                                            {renderChatbotActionPayloadSection(
                                                thread.chatbot_action_execution_data.payload_data,
                                                "quick_reply_payload",
                                                "Template Button Payload",
                                                (thread?.chatbot_action_execution_data?.message?.length ?? 0) > 0
                                            )}
                                        </>
                                    }
                                </>

                    }
                </>
            )
        case "media":
            return (
                <>
                    {thread.media_data?.map((media, index) => {
                        return (
                            <React.Fragment key={index}>
                                {initialMessagePreivewOnField ? (
                                    <>
                                        <Grid container>
                                            <Grid item xs={12}>
                                                <Grid container sx={{ justifyContent: 'space-between' }}>
                                                    <Grid item className={styles.chat_message_reply_left_item} sx={{ mt: '2px' }}>
                                                        <Typography component="span" sx={{ fontSize: '14px', fontWeight: '500', color: 'black' }}>
                                                            {index === 0 && (
                                                                <span>
                                                                    {getMessage(thread) ? (
                                                                        <span>{getMessage(thread)}</span>
                                                                    ) : (
                                                                        <span>
                                                                            <CameraAltIcon
                                                                                style={{
                                                                                    color: 'rgba(0, 0, 0, 0.5)',
                                                                                    verticalAlign: 'middle'
                                                                                }}
                                                                            />
                                                                            &nbsp;Photo
                                                                        </span>
                                                                    )}
                                                                </span>
                                                            )}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item className={styles.chat_img_reply_item}>
                                                        <img
                                                            className={"clickable chat-reply-img"}
                                                            loading={"lazy"}
                                                            src={(thread.media_data?.length ?? 0) > 1 ? thread.media_data?.[0]?.aws_storage_media_url : media.aws_storage_media_url}
                                                            alt="img"
                                                            style={{ borderRadius: '10px', width: '100%', height: '100%', objectFit: 'cover' }}
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </>
                                ) : (
                                    <>
                                        <div style={{ position: "relative", cursor: "pointer" }} className="chat-reply-main-wrapper">
                                            {renderMediaMsg(
                                                media?.message_type_name?.toLowerCase() ?? '',
                                                media?.aws_storage_media_url ?? '',
                                                getMessage(thread)?.replace(patternToRemoveSource, ""),
                                                (media?.aws_storage_file_name?.length ?? 0) > 0 ? media?.aws_storage_file_name ?? '' : extractFileNameFromUrl(media?.aws_storage_media_url ?? '')
                                            )}
                                        </div>
                                    </>
                                )}
                            </React.Fragment>
                        )
                    })
                    }
                </>
            )
        case "messageReply":
            return (
                <>
                    {thread?.media_data?.map((media, ind) => {
                        return (
                            <React.Fragment key={ind}>
                                {media?.aws_storage_id ?
                                    (
                                        <>
                                            <Grid container>
                                                <Grid item xs={12}>
                                                {
                                                    renderMediaMsg(
                                                        media?.message_type_name?.toLowerCase() ?? '',
                                                        media?.aws_storage_media_url ?? '',
                                                        getMessage(thread)?.replace(patternToRemoveSource, ""),
                                                        (media?.aws_storage_file_name?.length ?? 0) > 0 ? media?.aws_storage_file_name ?? '' : extractFileNameFromUrl(media?.aws_storage_media_url ?? '')
                                                    )
                                                }
                                                </Grid>
                                            </Grid>
                                        </>
                                    ) : (
                                        <>
                                            <Grid container>
                                                <Grid item xs={12}>
                                                    {markDowntext(thread?.chatbot_thread_value?.replace(patternToRemoveSource, ""), `${styles.reactMarkdownStyle} ${styles.chat_reply_text} ${styles.chat_chatbot_text_hidden_label}`)}
                                                </Grid>
                                            </Grid>
                                        </>
                                    )
                                }
                            </React.Fragment>
                        )
                    })}
                </>
            )
        case "contact":
            return <ContactCard contactInfo={thread.contact_information as any} />
        case "location":
            return <div style={{ display: "flex", flexDirection: "column" }}><iframe src={`${thread?.chatbot_thread_value}`} title="location" style={{ border: 0 }} allowFullScreen loading="lazy" ></iframe><span><a rel="noreferrer" target='blank' href={thread?.chatbot_thread_value ?? undefined}>{thread?.chatbot_thread_value}</a></span></div>
        case "audio":
            return (
                <>
                    <div>
                        {getMessage(thread) &&
                            <span>{getMessage(thread)}</span>
                        }
                    </div>
                    <CallAudio
                        audioURL={thread.media_data?.[0]?.aws_storage_media_url ?? ""}
                        waveLoading={false}
                        setWaveLoading={(() => {}) as React.Dispatch<React.SetStateAction<boolean>>}
                        timeToScroll={typeof timeToScroll === "number" ? timeToScroll : timeToScroll ? Number(timeToScroll) || null : null}
                        currentAudioAnalysis={null}
                    />
                </>
            )
        default:
            return (
                <>
                    {markDowntext(defaultCaseReturnText ?? "", "")}
                </>
            );
    }
}

export function renderThreadMsg(chatbotThread: RenderThreadMsgInput, textType: string, initialMessagePreivewOnField?: boolean, targetRef?: React.RefObject<HTMLElement | null>): React.ReactNode {
    if (!chatbotThread) {
        return null;
    }

    const threadFields = chatbotThread as ThreadMsgFields;
    let message_format_id = 1;
    let thread: string | WhatsAppThreadMessageJson | unknown = threadFields.chatbot_thread_value;

    if (threadFields.chatbot_route_source && threadFields.chatbot_route_source.toLowerCase() === "whatsapp") {
        if (isJsonString(threadFields.chatbot_thread_value)) {
            const parsedJson = JSON.parse(threadFields.chatbot_thread_value as string) as WhatsAppThreadMessageJson | string;
            if (typeof parsedJson === "object" && parsedJson !== null) {
                const messageFormatId = parsedJson.message_format_id;
                if (messageFormatId) {
                    if (messageFormatId === 1) {
                        return renderThreadMsgByType(textType, message_format_id, chatbotThread, initialMessagePreivewOnField, 1, getMessage(chatbotThread)?.replace(patternToRemoveSource, ""), targetRef);
                    } else if (messageFormatId === 8 || messageFormatId === 9) {
                        if (
                            parsedJson.message_fields &&
                            parsedJson.message_fields.type &&
                            interactiveMessageTypes.includes(parsedJson.message_fields.type)
                        ) {
                            return <WaInteractiveMessagePreview interactiveObj={parsedJson.message_fields} />;
                        } else if (parsedJson?.message_fields?.type?.toLowerCase() === "order_details") {
                            const params = parsedJson?.message_fields?.action?.parameters;
                            const bodyText = parsedJson?.message_fields?.body?.text;
                            const orderStatus = threadFields.order_status ?? params?.order?.status ?? "";

                            return (
                                <OrderDetailTemplatePreview
                                    productItems={params?.order?.items}
                                    currency={params?.currency}
                                    totalAmount={params?.total_amount}
                                    referenceId={params?.reference_id}
                                    bodyText={bodyText}
                                    orderStatus={orderStatus}
                                />
                            );
                        }
                    } else if (messageFormatId === 20) {
                        const mediaData = parsedJson?.message_fields;
                        const mediaType = mediaData?.type ?? "";
                        const mediaUrl = mediaData?.link ?? "";
                        const mediaCaption = mediaData?.caption ?? "";

                        return renderMediaMsg(mediaType, mediaUrl, mediaCaption, extractFileNameFromUrl(mediaUrl));
                    }
                    return thread as React.ReactNode;
                } else {
                    const defaultReturnedText = parsedJson?.message
                        ? parsedJson.message.replace(patternToRemoveSource, "")
                        : (thread as string);
                    return renderThreadMsgByType(textType, message_format_id, chatbotThread, initialMessagePreivewOnField, 1, defaultReturnedText, targetRef);
                }
            } else {
                return renderThreadMsgByType(textType, message_format_id, chatbotThread, initialMessagePreivewOnField, "", getMessage(chatbotThread)?.replace(patternToRemoveSource, ""), targetRef);
            }
        } else {
            return renderThreadMsgByType(textType, message_format_id, chatbotThread, initialMessagePreivewOnField, "", getMessage(chatbotThread)?.replace(patternToRemoveSource, ""), targetRef);
        }
    } else {
        if (isJsonString(threadFields.chatbot_thread_value)) {
            thread = JSON.parse(threadFields.chatbot_thread_value as string) as WhatsAppThreadMessageJson;
            if (typeof thread === "object" && thread !== null && "response" in thread && thread.response) {
                thread = thread.response;
            }
            if (typeof thread === "object" && thread !== null && (thread as WhatsAppThreadMessageJson).message_format_id === 4) {
                message_format_id = 4;
            } else if (typeof thread === "object" && thread !== null && (thread as WhatsAppThreadMessageJson).message_format_id != null) {
                message_format_id = Math.trunc((thread as WhatsAppThreadMessageJson).message_format_id as number);
            }
        }
        if(threadFields){
            return renderThreadMsgByType(textType, message_format_id, chatbotThread, initialMessagePreivewOnField, "", threadFields.chatbot_thread_value ?? undefined, targetRef);
        }
    }
}

export const renderUserMsg = (thread: currentActiveThreadChatbotThreadData | undefined, targetRef: React.RefObject<HTMLElement | null>) => {
    if (!thread) {
        return renderThreadMsg(thread, getMessageType(thread), false, targetRef);
    }

    const actionTypeInLowerCase = thread.action_type_name?.toLowerCase() ?? "";

    switch(actionTypeInLowerCase){
        case USER_MESSAGE_ACTION_TYPES["TEXT"]?.toLowerCase():
            return renderThreadMsg(thread, getMessageType(thread), false, targetRef);

        case USER_MESSAGE_ACTION_TYPES["MEDIA"]?.toLowerCase():
            return <UserMediaMessages thread={thread} />

        case USER_MESSAGE_ACTION_TYPES["AI_MESSAGE_EXECUTION"]?.toLowerCase():
            return renderThreadMsg(thread?.action_execution_data, getMessageType(thread?.action_execution_data), false, targetRef);

        case ACTION_TYPE_NAME["VOICE_CALL"]?.toLowerCase():
            return <VoiceCallAction actionData={thread.chatbot_action_execution_data as unknown as voiceCallActionExecutionData} />;

        case INSTAGRAM_ACTION_TYPES["IG_DM_TEXT_RECEIVED"]?.toLowerCase():
            const message = thread?.chatbot_action_execution_data?.message ?? "";
            return renderFormattedMsg(message);

        case INSTAGRAM_ACTION_TYPES["IG_COMMENT_RECEIVED"]?.toLowerCase():
            const commentMessage = thread?.chatbot_action_execution_data?.comment_message ?? "";
            return renderFormattedMsg(commentMessage);

        default: 
            return renderThreadMsg(thread, getMessageType(thread), false, targetRef);
    }
} 

interface ChatbotActionOrderJson {
    order?: {
        items?: unknown;
        status?: string;
    };
    currency?: string;
    total_amount?: unknown;
    reference_id?: string;
}

type ChatbotActionMessageData = chatbot_action_execution_data & {
    order_json?: ChatbotActionOrderJson;
    order_status?: string;
    whatsapp_body_text?: string;
    wa_header_text?: string;
};

export function renderBotMsg(actionType: string, actionData: ChatbotActionMessageData | undefined, index: number, targetRef: React.RefObject<HTMLElement | null>, thread: currentActiveThreadChatbotThreadData) {
    let action = actionType?.toLowerCase() ?? "";
    
    switch (action) {
        case ACTION_TYPE_NAME["TEXT"]?.toLowerCase():
            return renderFormattedMsg(actionData?.message ?? "");

        case ACTION_TYPE_NAME["TEMPLATE"]?.toLowerCase():
            return <ChatLogsTemplatePreview actionData={actionData} key={index} ref={targetRef} />;

        case ACTION_TYPE_NAME["SEND_MEDIA"]?.toLowerCase():
            const mediaData = actionData?.media;
            const mediaType = mediaData?.type ?? "";
            const mediaUrl = mediaData?.url ?? "";
            const mediaCaption = mediaData?.caption ?? "";

            return renderMediaMsg(mediaType, mediaUrl, mediaCaption, extractFileNameFromUrl(mediaUrl));

        case ACTION_TYPE_NAME['SEND_ORDER_DETAIL_TEMPLATE']?.toLowerCase():
            const orderJson = actionData?.order_json;
            const orderStatus = actionData?.order_status ?? orderJson?.order?.status ?? '';

            return <OrderDetailTemplatePreview
                productItems={orderJson?.order?.items}
                currency={orderJson?.currency}
                totalAmount={orderJson?.total_amount}
                referenceId={orderJson?.reference_id}
                bodyText={actionData?.whatsapp_body_text}
                orderStatus={orderStatus}
            />;

        case ACTION_TYPE_NAME["CUSTOM_API"]?.toLowerCase():
            return <CustomAPIAction actionData={actionData} thread={thread} />;

        case ACTION_TYPE_NAME["SAVE_DATA"]?.toLowerCase():
            return <SaveVariableAction actionData={actionData} />;

        case ACTION_TYPE_NAME["RESET_DATA"]?.toLowerCase():
            return <ResetVariableAction actionData={actionData} />;

        case ACTION_TYPE_NAME["VARIABLE_ASSIGNMENT"]?.toLowerCase():
            return <VariableAssignmentAction actionData={actionData} />;

        case ACTION_TYPE_NAME["CAROUSEL_TEMPLATE"]?.toLowerCase():
            return actionData?.wa_header_text || ""; 

        case ACTION_TYPE_NAME["AWAIT_WEBHOOK"]?.toLowerCase(): 
            return <AwaitWebhookAction actionData={actionData} />;

        case ACTION_TYPE_NAME["SAVE_CONTACT"]?.toLowerCase():
        case ACTION_TYPE_NAME["REMOVE_CONTACT"]?.toLowerCase():
            return <SaveAndRemoveContactAction actionData={actionData as unknown as saveAndRemoveContactExecutionData} actionType={actionType} />;

        case ACTION_TYPE_NAME["TALK_TO_AGENT"]?.toLowerCase():
            return <TalkToAgentAction actionData={actionData as unknown as talkToAgentExecutionData} />;

        case ACTION_TYPE_NAME["VOICE_CALL"]?.toLowerCase():
            return <VoiceCallAction actionData={actionData as unknown as voiceCallActionExecutionData} />;

        case ACTION_TYPE_NAME["ASSIGN_TAG"]?.toLowerCase():
        case ACTION_TYPE_NAME["REMOVE_TAG"]?.toLowerCase():
            return <AssignAndRemoveTagAction actionData={actionData as unknown as assignAndRemoveTagExecutionData} actionType={actionType} />;

        case USER_MESSAGE_ACTION_TYPES["AI_MESSAGE_EXECUTION"]?.toLowerCase():
            return renderThreadMsg(actionData, getMessageType(actionData), false, targetRef);

        case ACTION_TYPE_NAME["RETRIEVE_CONTACT"]?.toLowerCase():
            return <RetrieveContactActionLog actionData={actionData} />;

        case INSTAGRAM_ACTION_TYPES["SEND_IG_DM_TEXT"]?.toLowerCase():
            return renderFormattedMsg(actionData?.message ?? "");

        case INSTAGRAM_ACTION_TYPES["REPLY_TO_IG_COMMENT"]?.toLowerCase():
            return renderFormattedMsg(actionData?.comment_message ?? "");

        case INSTAGRAM_ACTION_TYPES["REPLY_DM_TO_IG_COMMENT"]?.toLowerCase():
            return renderFormattedMsg(actionData?.message ?? "");

        default:
            return (
                <Markdown
                    remarkPlugins={[remarkGfm]}
                    rehypePlugins={[
                        [rehypeExternalLinks, { target: '_blank', rel: ['noopener', 'noreferrer'] }],
                    ]}
                    className={`${styles.reactMarkdownStyle} ${styles.chat_reply_text}`}
                >
                    {JSON.stringify(actionData)}
                </Markdown>
            )
    }
}